export const TRANSPORT_REQUEST_REPORT_ID = 25;
export const TRANSPORT_TRIPS_BY_DOCTOR_TYPE_REPORT_ID = 29;
export const TRANSPORT_REPORT_IDS = [TRANSPORT_REQUEST_REPORT_ID, TRANSPORT_TRIPS_BY_DOCTOR_TYPE_REPORT_ID];

export const FIRST_DAY_OF_MONTH_FREQUENCY_IDS = [7, 8];
